module.exports = __webpack_public_path__ + "media/icons/context-plus-27c8ca78.svg";